import { buildUseCurrentBreakpointHook } from "@thelabnyc/thelabui/src/hooks/layout";

import * as layout from "../styles/layout";

export const useCurrentBreakpoint = buildUseCurrentBreakpointHook({
    belowMedium: `screen and ${layout.belowMedium}`,
    aboveMedium: `screen and ${layout.aboveMedium}`,
});

export type BreakpointState = ReturnType<typeof useCurrentBreakpoint>;
